import {useUpmPlantTimezone} from '@hconnect/upm'
import {useMediaQuery, useTheme} from '@mui/material'

import {PagePerformanceReviewHeaderActions} from '../components'
import {
  PerformanceReviewKpisContainer,
  KpiTrendContainer,
  PerformanceReviewCommentsContainer
} from '../containers'
import {usePerformanceReviewPageState} from '../hooks'
import {PerformanceReviewLayout} from '../layouts'

type Props = {
  plantId: string
  titleSlot?: React.ReactNode
  /**
   * Set to `true` when rendered on the legacy blue surface (hproduce app) so the
   * header month selector uses on-blue (white) text. Suite keeps the default.
   */
  inverted?: boolean
}

export const PerformanceReviewPage = ({plantId, titleSlot, inverted = false}: Props) => {
  const timezone = useUpmPlantTimezone(plantId)
  const {
    kpiType: selectedKpi,
    setKpiType: setSelectedKpiType,
    onSelectedDateChange,
    selectedDate,
    commentsKpiTypes,
    setCommentsKpiTypes
  } = usePerformanceReviewPageState({timezone})
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const commentsSlot = (
    <PerformanceReviewCommentsContainer
      plantId={plantId}
      selectedDate={selectedDate}
      selectedCommentsKpiTypes={commentsKpiTypes}
      onSelectedCommentsKpiTypesChange={setCommentsKpiTypes}
    />
  )

  return (
    <PerformanceReviewLayout
      titleSlot={titleSlot}
      headerActionsSlot={
        <PagePerformanceReviewHeaderActions
          onSelectedDateChange={onSelectedDateChange}
          selectedDate={selectedDate}
          timezone={timezone}
          inverted={inverted}
        />
      }
      kpisSlot={
        !isMobile ? (
          <PerformanceReviewKpisContainer
            plantId={plantId}
            selectedKpi={selectedKpi}
            selectedDate={selectedDate}
            onKpiRowClick={setSelectedKpiType}
          />
        ) : null
      }
      trendSlot={
        selectedKpi ? (
          <KpiTrendContainer
            plantId={plantId}
            selectedKpi={selectedKpi}
            selectedDate={selectedDate}
            onSelectedKpiChange={setSelectedKpiType}
            {...(isMobile && {
              enableKpiSelection: true,
              commentsSlot
            })}
          />
        ) : null
      }
      commentsSlot={!isMobile ? commentsSlot : null}
    />
  )
}
